export enum APPLICATION_ROLES {
  NEVIS_VITOGUIDE_INVITATION = 'NEVIS-Vitoguide.Invitation',
  VITOGUIDE_DEFAULT = 'Vitoguide.Default',
  RSA_DEFAULT = 'Rsa.Default',
  VICARE_DEFAULT = 'Vicare.Default',
  VITOGUIDE_CAN_MANAGE_SUBSCRIPTIONS = 'CUAR_Vitoguide-CAN_MANAGE_SUBSCRIPTIONS',
  VITOGUIDE_CAN_MANAGE_NOTIFICATIONS = 'CUAR_Vitoguide-NOTIFICATION',
  RSA_XOTA_UPDATE_BUTTON = 'Rsa.Xotaupdatebutton',
  VITOGUIDE_XOTA_UPDATE_BUTTON = 'Vitoguide.Xotaupdatebutton',
  RSA_ACCESS_FEEDBACK = 'Rsa.Accessfeedback',
  VIGUIDE_HEATING_SYSTEMS_OVERVIEW = 'Viguide.Heatingsystemsoverview',
  VITOGUIDE_HEATING_SYSTEMS_OVERVIEW_V2 = 'Vitoguide.Heatingsystemsoverview',
}

export enum BUSINESS_ROLES {
  DEFAULT_LITE_ACCOUNT = 'CUBR_Default_LiteAccount',
  BUILDING_MANAGER = 'BuildingManager',
}

export interface HasAccessToDiagnostics {
  isStoreReady: boolean;
  hasAccessToDiagnostics: boolean;
}

export interface InstallationsListInitModel {
  companyId: string;
  isRsaUser: boolean;
  installationsCount: number;
}

export enum AnalyticsClientRole {
  internal = 'internal',
  external = 'external',
  unknown = 'unknown',
}

export interface ConnectivityRankingPositions {
  userPosition: string;
  allPositions: string;
}

export interface RemoteDiagnosticsAccessStatus {
  hasAccessToDiagnostics: boolean;
  isStoreReady: boolean;
}

export enum DashboardUserType {
  Rsa,
  Maintainer,
  EndUser,
}

export const requiredApplicationRoles = [
  APPLICATION_ROLES.RSA_DEFAULT,
  APPLICATION_ROLES.VICARE_DEFAULT,
  APPLICATION_ROLES.VITOGUIDE_DEFAULT,
];

export const xotaApplicationRoles = [
  APPLICATION_ROLES.RSA_XOTA_UPDATE_BUTTON,
  APPLICATION_ROLES.VITOGUIDE_XOTA_UPDATE_BUTTON,
];
